import { render, staticRenderFns } from "./DataloggersView.vue?vue&type=template&id=6edc99dc&"
import script from "./DataloggersView.vue?vue&type=script&lang=js&"
export * from "./DataloggersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports